import { generateDummyPassword } from './utils';

export const isProductionEnvironment = process.env.NODE_ENV === 'production';

// ── Open Finance unavailability messages ────────────────────────────────
// Used across UI components, API routes, AI tools, and server actions
// when the open-finance-connect feature flag is disabled.

export const OPEN_FINANCE_UNAVAILABLE = {
  /** Short error label for API JSON responses */
  errorTitle: 'Conexão de contas temporariamente indisponível',
  /** Full user-facing message with apology */
  userMessage:
    'Pedimos desculpas pelo inconveniente. Estamos com uma instabilidade temporária na conexão de contas bancárias. Por favor, tente novamente mais tarde.',
  /** Shorter inline message for tight UI spaces (e.g. selector rows) */
  inlineMessage: 'Pedimos desculpas, conexão temporariamente indisponível',
  /** Server action error message */
  actionMessage:
    'Pedimos desculpas pelo inconveniente. A conexão de contas está temporariamente indisponível. Por favor, tente novamente mais tarde.',
  /** Toast title */
  toastTitle: 'Pedimos desculpas pelo inconveniente',
  /** Toast description */
  toastDescription:
    'Estamos com uma instabilidade temporária na conexão de contas bancárias. Por favor, tente novamente mais tarde.',
  /** AI tool instruction — tells the model how to communicate the outage */
  aiToolInstruction:
    'A conexão de contas bancárias está temporariamente indisponível devido a uma instabilidade no serviço. Peça desculpas pelo inconveniente, explique que é uma situação temporária e que ele pode tentar novamente mais tarde.',
  /** Extended AI tool instruction with existing-data fallback */
  aiToolInstructionWithFallback:
    'A conexão de contas bancárias está temporariamente indisponível devido a uma instabilidade no serviço. Peça desculpas pelo inconveniente, explique que é uma situação temporária e que ele pode tentar novamente mais tarde. Se ele já tiver contas conectadas, ofereça ajuda com os dados que já existem.',
} as const;

export const isTestEnvironment = Boolean(
  process.env.PLAYWRIGHT_TEST_BASE_URL ||
    process.env.PLAYWRIGHT ||
    process.env.CI_PLAYWRIGHT,
);

export const DUMMY_PASSWORD = generateDummyPassword();

// Número mestre para pular validação de WhatsApp durante cadastro
// Defina em env como MASTER_PHONE_NUMBER. Aceita com ou sem caracteres não numéricos.
// Ex.: 5599999999999 ou (99) 99999-9999 com prefixo 55.
// Server-side env ONLY (#5879): a NEXT_PUBLIC_ variant inlines the test
// numbers into the public client bundle. Client code that needs the
// master-phone skip decision gets it from the server (checkPhoneExistence /
// mobile check-existence return `skipOtp`).
export const MASTER_PHONE_NUMBER = (() => {
  const raw = process.env.MASTER_PHONE_NUMBER || '';
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('55')) return digits;
  // Se o número tem 11 dígitos sem o 55, prefixa automaticamente
  if (digits.length === 11) return `55${digits}`;
  return digits;
})();

// Segundo número mestre para múltiplas contas de teste (ex: e2e mobile)
export const MASTER_PHONE_NUMBER_2 = (() => {
  const raw = process.env.MASTER_PHONE_NUMBER_2 || '';
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('55')) return digits;
  if (digits.length === 11) return `55${digits}`;
  return digits;
})();
